module.exports = __webpack_public_path__ + "static/result-500.02c0832f.png";